import axiosInstance from "../services/axiosInstance";

export const GetListNotifications = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/notification/lists",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetNotificatinDetail = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/notification/detail",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const GetRealtimeSocketTicket = async (payload) => {
  try {
    const response = await axiosInstance.get("console/realtime/socket-ticket", {
      params: payload,
    });

    return response.data;
  } catch (error) {
    return error.response?.data || error.response;
  }
};
